import accountsMarketplaceManifest from 'store/domains/adsimple/accountsMarketplace.manifest'

export default {
  accountsMarketplace: {
    manifest: accountsMarketplaceManifest,
    i18nNamespaces: ['accounts_marketplace'],
  },
}
